import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { INews } from '@core/interfaces/news.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NewsService {
  constructor(private readonly http: HttpClient) {}

  public getNews(languageCode: string): Observable<INews[]> {
    return this.http.get<INews[]>(`news/all/${languageCode}`);
  }

  public getNewsAdmin(languageCode: string): Observable<INews[]> {
    return this.http.get<INews[]>(`news/admin/all/${languageCode}`);
  }

  public createNews(news: INews): Observable<INews> {
    return this.http.post<INews>('news/admin', news);
  }

  public updateNews(id: string, news: INews): Observable<INews> {
    return this.http.put<INews>(`news/admin/${id}`, news);
  }

  public deleteNews(id: string): Observable<INews> {
    return this.http.delete<INews>(`news/admin/${id}`);
  }
}
